import { Link } from "react-router-dom";
import { Mail, Globe, Phone, MessageCircle } from "lucide-react";
import { Logo } from "@/components/Header";
import { SITE } from "@/lib/api";

export function Footer() {
  return (
    <footer className="bg-[#0A192F] text-slate-300 relative grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div className="space-y-4">
          <Logo light />
          <p className="text-sm text-slate-400 max-w-xs">Providing Smart Logistics Solutions Across The World. We deliver excellence in shipping, courier services, and package tracking with our global network of trusted partners.</p>
        </div>
        <div className="space-y-3 text-sm">
          <p className="font-display text-white font-semibold">Services</p>
          <Link to="/track" className="block hover:text-[#FF6B00]" data-testid="footer-track-link">Track a consignment</Link>
          <Link to="/book" className="block hover:text-[#FF6B00]" data-testid="footer-book-link">Book a shipment</Link>
          <Link to="/contact" className="block hover:text-[#FF6B00]" data-testid="footer-contact-link">Contact support</Link>
          <Link to="/sign-up" className="block hover:text-[#FF6B00]" data-testid="footer-sign-up-link">Create a customer account</Link>
          <Link to="/admin/login" className="block hover:text-[#FF6B00]" data-testid="footer-admin-login-link">Admin login</Link>
        </div>
        <div className="space-y-3 text-sm">
          <p className="font-display text-white font-semibold">Call us · Toll Free Support</p>
          <a href={SITE.tel} className="flex items-center gap-2 hover:text-[#FF6B00]" data-testid="footer-phone"><Phone className="h-4 w-4 shrink-0" /> {SITE.phone}</a>
          <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#FF6B00]" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 shrink-0" /> WhatsApp: {SITE.phone}</a>
          <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-[#FF6B00] break-all" data-testid="footer-email">
            <Mail className="h-4 w-4 shrink-0" /> {SITE.email}
          </a>
          <p className="flex items-center gap-2" data-testid="footer-domain"><Globe className="h-4 w-4" /> {SITE.domain}</p>
        </div>
      </div>
      <div className="border-t border-white/10 pt-5 pb-24 sm:pb-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} Inla Shipping Hub · {SITE.domain}</div>
    </footer>
  );
}
